/**
 * Navigation
 */

import {
	debounce,
	getRootVar
} from '../../../shared/utils';

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator from '../../../shared/dom/manipulator';
import EventHandler from '../../../shared/dom/event-handler';

import Nav from '../../../shared/components/nav';
import Drawer from '../../../shared/components/drawer';

// -------
// Private
// -------

const NAME      = 'menu';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

const pageMenu = SelectorEngine.findOne('#page-menu-drawer');

let mainNavInstance;

const checkMenuPlacement = () => {
	const targetWidth = parseInt(getRootVar(`${window.pageInstance.prefix}breakpoint-xl`), 10) ?? 0;

	if (targetWidth) {
		const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

		pageMenu.dataset.placement = (screenWidth < targetWidth) ? 'end' : 'top';
	}
};

/**
 * Drawer (Navigationsoverlay)
 */
const setupDrawer = () => {
	const trigger = SelectorEngine.findOne('[aria-controls="page-menu-drawer"]');
	const drawer  = new Drawer(pageMenu, {
		noHeader: true,
		label: 'Navigation',
		// onInit   : (event) => {
		// 	const componentCloseButton = SelectorEngine.findOne('.drawer__header > .drawer-close', event.target);
		//
		// 	if (componentCloseButton) {
		// 		componentCloseButton.remove();
		// 	}
		// },
		onShow: function () {
			Manipulator.addClass(trigger, '_active');
		},
		onHidden: () => {
			Manipulator.removeClass(trigger, '_active');
		}
	});

	EventHandler.on(trigger, 'click.ifab.pageMenuDrawer', (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (event.delegateTarget.classList.contains('-active')) {
			drawer.hide();
		} else {
			drawer.show();
		}
	});

	// FIX Chrome ´history back´
	// Öffnet man einen Layer und betätigt darin einen Link zu einer andere Seite, dann macht Chrome in genau
	// diesem Moment anscheinend einen aktuellen "Snapshot" deer Seite und verwendet diesen für ein ´History
	// back´. Etgo, der Layer ist wieder geöffnet bei einem ´History back´ von o. g. Link aus.
	// Soviel könnte ich gar nicht essen wie ich ko... könnte :(.
	const links = SelectorEngine.find('a:not(a[href=""])', pageMenu);

	for (const link of links) {
		EventHandler.on(link, 'click', event => {
			drawer.hide();
		});
	}

	// Menütyp bestimmen/erkennen & überwachen.
	checkMenuPlacement();
	window.addEventListener('resize', debounce(checkMenuPlacement, 300));
	window.addEventListener('orientationchange', debounce(checkMenuPlacement, 300));
};

/**
 * Initialisierung der eigentlichen Navigationsliste.
 */
const navigation = () => {
	const nav = SelectorEngine.findOne('#main-nav');

	if (nav) {
		mainNavInstance = new Nav(nav, {
			closeByOutsideClick: false,
			closeByEsc         : false,
			labelSubmenu       : (window.pageInstance.tm) ? window.pageInstance.tm.translate('ariaLabelSubmenu') : 'Submenu for %s',
			labelSubmenuTrigger: (window.pageInstance.tm) ? window.pageInstance.tm.translate('ariaLabelSubmenuTrigger') : 'Show submenu for %s',
			useReveal          : true, // { visibleDisplay: 'flex' },
			onHide             : () => {
				// Manipulator.addClass(event.relatedMenu, '-will-hide');
			},
			onHidden           : () => {
				// Manipulator.removeClass(event.relatedMenu, '-will-hide');
			},
			onShow             : () => {
				// Manipulator.addClass(event.relatedMenu, '-will-show');
			},
			onShown            : () => {
				// Manipulator.removeClass(event.relatedMenu, '-will-show');
			}
		});

		mainNavInstance.showCurrentTree();

		// const curPageItem = SelectorEngine.findOne('[aria-current="page"]');
		//
		// if (appMenuBody && curPageItem) {
		// 	scrollElementIntoView(curPageItem, appMenuBody, 'vertical');
		// }
	}
};

// -------
// Public
// -------

const menu = () => {
	if (pageMenu) {
		setupDrawer();
		navigation();
	}
};

// Export
export default menu;
